var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17806 14.569C9.2698 14.7022 9.39255 14.8112 9.53575 14.8864C9.67895 14.9617 9.83829 15.001 10.0001 15.001C10.1618 15.001 10.3212 14.9617 10.4644 14.8864C10.6076 14.8112 10.7303 14.7022 10.8221 14.569L19.8221 1.569C19.9262 1.41906 19.9873 1.24343 19.9987 1.06121C20.0101 0.87898 19.9713 0.697123 19.8865 0.535394C19.8018 0.373665 19.6744 0.238248 19.5181 0.143858C19.3618 0.049468 19.1826 -0.000286344 19.0001 1.23965e-06H1.00006C0.817902 0.000753649 0.639397 0.0511479 0.483739 0.145764C0.328082 0.24038 0.201162 0.375639 0.116628 0.536994C0.0320935 0.698349 -0.0068559 0.879696 0.00396806 1.06153C0.014792 1.24337 0.0749798 1.41881 0.178059 1.569L9.17806 14.569Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.c31f24fb8ddcc86bd70ab1c3c9b9ddab.svg";
export { ForwardRef as ReactComponent };